module.exports = {
  namespaced: true,

  state: {
    /**
     * Items
     * @type {Array}
     */
    items: [],

    /**
     * Active item index
     * @type {Number}
     */
    index: 0,

    /**
     * Whether viewer is open or closed
     * @type {Boolean}
     */
    isOpen: false,

    /**
     * Breadcrumbs array to add to viewer
     * @type {Array}
     */
    breadcrumbs: [],

    /**
     * Optional route object to a gallery
     * - Shows gallery grid button in viewer ui
     * @type {Object}
     */
    gallery: {}
  },

  actions: {
    /**
     * Open viewer
     * @param  {Object} obj { items: {}, index: 0 }
     */
    open ({ commit }, obj) {
      commit('SET_ITEMS', obj.items)
      commit('SET_INDEX', obj.index || 0)
      commit('SET_BREADCRUMBS', obj.breadcrumbs)
      commit('SET_GALLERY', obj.gallery)
      commit('SET_IS_OPEN', true)
    },

    /**
     * Close viewer
     */
    close ({ commit }) {
      commit('SET_IS_OPEN', false)

      // Must match duration in .Viewer--enter
      setTimeout(() => {
        commit('SET_ITEMS', [])
        commit('SET_INDEX', 0)
        commit('SET_BREADCRUMBS', [])
        commit('SET_GALLERY', {})
      }, 300)
    },

    /**
     * Set index
     */
    setIndex ({ commit }, index) {
      commit('SET_INDEX', index)
    }
  },

  mutations: {
    SET_ITEMS (state, items) {
      state.items = items
    },

    SET_INDEX (state, index) {
      state.index = index
    },

    SET_BREADCRUMBS (state, value) {
      state.breadcrumbs = value
    },

    SET_GALLERY (state, route) {
      state.gallery = route
    },

    SET_IS_OPEN (state, value) {
      state.isOpen = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/viewer.js